import { DataImage } from 'app/interfaces/DataImage';

export type PreProcessingOptions = {
  need_log_rescale?: boolean;
  crop_collimation?: boolean;
  crop_rect?: number[];
  // inverted_pixels?: boolean;
  photometric_interpretation?: string;
  has_anti_scattering_grid?: boolean;
};

export type ProcessingOptions = {
  lowLattitudeCompression?: number;
  pyramid_decomposition?: number;
  funnel_decomposition?: number;
  funnel_size_limit?: number;
  intensities: number[];
  denoise_intensities: number[];
  black_relative_steepness: number;
  white_relative_steepness: number;
  general_steepness: number;
  centering_quantile: number;
};

type ImageProcessingModuleDataImage = {
  data: Uint16Array;
  width: number;
  height: number;
  bytes_per_pixel: number;
  maxPixelValue: number;
  minPixelValue: number;
  windowCenter: number;
  windowWidth: number;
  collimation_rect: [number, number, number, number];
};

export type ImageProcessingModule = {
  processImage: (
    image: DataImage,
    processingOptions: ProcessingOptions & PreProcessingOptions
  ) => Promise<ImageProcessingModuleDataImage>;
};

const imageProcessing = (): ImageProcessingModule => (window as any)?.nodeModules?.imageProcessing;

export default imageProcessing;
